var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",on:{"click":_vm.onClick}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"dummy"}),_c('img',{attrs:{"src":_vm.data.images[0].url}})]),_c('h3',[_vm._v(" "+_vm._s(_vm.data.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }